var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDacast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1.325 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.496 5.454c1.668 1.894 3.395 9.104-.531 14.037s-9.743 4.5-9.743 4.5H.759c-.948 0-.664-.646-.499-.799.164-.153 19.236-17.738 19.236-17.738zM18.716 4.268l-7.373 6.791S.248.84.087.69C-.073.54-.04.024.426.007c.467-.017 2.413 0 8.722 0 6.307 0 9.568 4.261 9.568 4.261z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDacast);
export default __webpack_public_path__ + "static/media/dacast.56a27f71fb052c23d3ab38a4a9b88ee6.svg";
export { ForwardRef as ReactComponent };